import React, { Component } from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  selectAuthErrors,
  selectAuthMessage,
  selectAuthPending,
  selectAuthAction,
} from '../../redux/auth/auth.selectors';
import authActions from '../../redux/auth/auth.actions';
import { serializeForm } from '../../utils/selectors';
import { StyledSignupPageWrapper } from './styles';
import SignupFormComponent from '../../components/SignupFormComponent-v2/SignupFormComponent';
import bgImage from '../../assets/images/backgrounds/signInSignUp.jpg';
import { StyledLayout } from '../../screens/AuthScreen-v2/styles';

export class SignupContainer extends Component {
  componentDidMount() {
    const query = queryString.parse(this.props.location.search);
    if (query.token && query.user) {
      this.props.setAuthInfoFromSocialLogin(
        query.token,
        query.user,
        query.step
      );
    }
  }

  setReCaptchaToken = (token) => {
    console.log('Token', token);
    this.setState({ token });
  };

  signInFacebook = () => {
    this.props.signInFacebook();
  };

  signInGoogle = () => {
    this.props.signInGoogle();
  };

  signUp = (event) => {
    event.preventDefault();
    const values = serializeForm(event.target);
    this.props.fetchSignupPending({ ...values, token: this.state.token });
  };

  render() {
    const { action, errors, message } = this.props;
    return (
      <StyledLayout login bgImage={bgImage}>
        <StyledSignupPageWrapper>
          <SignupFormComponent
            signUp={this.signUp}
            signInFacebook={this.signInFacebook}
            signInGoogle={this.signInGoogle}
            errors={action === 'signup' ? errors : {}}
            message={action === 'signup' ? message : ''}
            setReCaptchaToken={this.setReCaptchaToken}
            token={this.state?.token}
          />
        </StyledSignupPageWrapper>
      </StyledLayout>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  errors: selectAuthErrors,
  message: selectAuthMessage,
  pending: selectAuthPending,
  action: selectAuthAction,
});

const mapDispatchToProps = {
  fetchSigninPending: authActions.fetchSigninPending,
  clearAuthState: authActions.clearAuthState,
  signInFacebook: authActions.fetchSigninFacebookPending,
  signInGoogle: authActions.fetchSigninGooglePending,
  setAuthInfoFromSocialLogin: authActions.setAuthInfoFromSocialLogin,
  fetchSignupPending: authActions.fetchSignupPending,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupContainer);
